import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.933 5h-6.933v16h13v-8","key":"svg-0"}],["path",{"d":"M14 17h-5","key":"svg-1"}],["path",{"d":"M9 13h5v-4h-5v4","key":"svg-2"}],["path",{"d":"M15 5v-2","key":"svg-3"}],["path",{"d":"M18 6l2 -2","key":"svg-4"}],["path",{"d":"M19 9h2","key":"svg-5"}]]

const IconAd2 = createReactComponent('outline', 'ad-2', 'Ad2', __iconNode);

export default IconAd2;